var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('Hero',{attrs:{"title":"Faça parte da transformação de vidas e empresas por meio da atividade física.","image":'foto-hero-home.jpg',"height":"75vh","search":true}}),_c('WhoWeAre'),_c('Faq')],1)}
var staticRenderFns = []

export { render, staticRenderFns }